import { useEffect, useRef } from 'react'
import { useAtomValue } from 'jotai'
import { useNavigate, useLocation } from 'react-router'
import { staff } from '../store'

export function useRequireStaff() {
  const authState = useAtomValue(staff.staffSessionStatusAtom)
  const navigate = useNavigate()
  const location = useLocation()
  const hasRedirected = useRef(false)

  useEffect(() => {
    if (authState === 'unauthenticated' && !hasRedirected.current) {
      hasRedirected.current = true
      navigate('/staff/login', { state: { from: location.pathname }, replace: true })
    }
  }, [authState, navigate, location.pathname])
}
